// extracted by mini-css-extract-plugin
module.exports = {"pagination":"sellers-view_pagination__1dzTt"};